import type { CreateStripePortalResponseType } from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useStripePortalCreate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "stripe-portal",
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as CreateStripePortalResponseType,
      ),
  });
};
